<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      ref="table"
      row-id="materialCode"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :radio-config="{ highlight: true, trigger: 'row' }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.materialStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.v_materialStatus }}
        </el-tag>
      </template>
      <template v-slot:displayCreateByName="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:displayModifyByName="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>

      <template v-slot:materialCategory="{ row }">
        <span
          >{{ row.mainMaterialCategoryName }} /
          {{ row.detailMaterialCategoryName }}</span
        >
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="row.defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            row.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],

  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { default: null, type: Object },
    loading: { type: Boolean, default: false },
    type: String,
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        // refresh: {
        //   query: () => this.$emit('reload'),
        // },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
          visible: this.type === 'checkbox',
        },
        {
          field: 'radio',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'radio',
          visible: this.type === 'radio',
        },
        {
          field: 'defaultImageUrl',
          width: 120,
          title: this.$l('INDEX.form_label_picture') || '图片',
          align: 'center',
          fixed: 'left',
          slots: { default: 'defaultImageUrl' },
        },
        {
          title: this.$l('INDEX.table_label_material_no') || '物料编号',
          field: 'materialNo',
          minWidth: 150,
          align: 'left',
          fixed: 'left',
        },
        {
          title: this.$l('INDEX.table_label_State') || '状态',
          width: 80,
          align: 'center',
          slots: { default: 'status' },
        },
        {
          title: this.$l('INDEX.table_label_materialCategory') || '物料分类',
          field: 'materialCategory',
          minWidth: 150,
          align: 'left',
          slots: { default: 'materialCategory' },
        },
        {
          title: this.$l('INDEX.table_label_materialName') || '中文名称',
          field: 'materialName',
          minWidth: 200,
          align: 'left',
        },
        {
          title: this.$l('INDEX.table_label_materialNameEn') || '英文名称',
          field: 'materialNameEn',
          minWidth: 200,
          align: 'left',
        },
        {
          title: this.$l('INDEX.table_label_materialDesc') || '材质',
          field: 'materialDesc',
          minWidth: 200,
          align: 'left',
        },
        {
          title: this.$l('INDEX.table_label_materialSpec_new') || '规格尺寸',
          field: 'materialSpec',
          minWidth: 150,
          align: 'left',
        },
        {
          title: this.$l('INDEX.table_label_custName') || '所属客户',
          field: 'custName',
          minWidth: 150,
          align: 'left',
        },
        {
          title: this.$l('INDEX.table_label_materialScmName') || '物料供应商',
          field: 'scmName',
          minWidth: 150,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
        },
        {
          title: this.$l('INDEX.table_label_brandName') || '所属品牌',
          field: 'brandName',
          minWidth: 100,
          align: 'left',
        },
        {
          title:
            this.$l('INDEX.table_label_customerMaterialNo') || '客户物料编号',
          field: 'customerMaterialNo',
          minWidth: 100,
          align: 'left',
        },
        {
          field: 'createByName',
          headerAlign: 'center',
          align: 'center',
          width: 160,
          title: this.$l('INDEX.creator') || '创建人',
          slots: { default: 'displayCreateByName' },
        },
        {
          field: 'createByName',
          headerAlign: 'center',
          align: 'center',
          width: 160,
          title: this.$l('INDEX.creator') || '修改人',
          slots: { default: 'displayModifyByName' },
        },
      ],
    }
  },
  methods: {
    choiceData() {
      if (this.type === 'checkbox') {
        return this.getCheckboxRecords()
      }
      if (this.type === 'radio') {
        return this.getRadioRecord()
      }
    },
    getRadioRecord() {
      const data = this.$refs.table.getRadioRecord()
      if (!data) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
    getCheckboxRecords() {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      if (!data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
  },
}
</script>
